import { render, staticRenderFns } from "./DialogBlockWrapper.vue?vue&type=template&id=5d1f54fa&scoped=true&"
import script from "./DialogBlockWrapper.vue?vue&type=script&lang=js&"
export * from "./DialogBlockWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DialogBlockWrapper.vue?vue&type=style&index=0&id=5d1f54fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1f54fa",
  null
  
)

export default component.exports